import { createTheme as o } from "./ghl-ui.es821.js";
import i from "./ghl-ui.es1120.js";
import t from "./ghl-ui.es1093.js";
const m = o({
  name: "Ellipsis",
  common: i,
  peers: {
    Tooltip: t
  }
}), l = m;
export {
  l as default
};
